import React, { useState, useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { SERVER_ERROR_EVENT } from '../services/api-client';
import { config } from '../config/config';

const GlobalErrorSnackbar: React.FC = () => {
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const handleServerError = (event: CustomEvent) => {
            setError(event.detail.message);
        };

        window.addEventListener(SERVER_ERROR_EVENT, handleServerError as EventListener);

        return () => {
            window.removeEventListener(SERVER_ERROR_EVENT, handleServerError as EventListener);
        };
    }, []);

    return (
        <Snackbar
            open={!!error}
            autoHideDuration={config.ui.snackbar.autoHideDuration}
            onClose={() => setError(null)}
            anchorOrigin={config.ui.snackbar.anchorOrigin}
        >
            <Alert onClose={() => setError(null)} severity="error" sx={{ width: '100%' }}>
                {error}
            </Alert>
        </Snackbar>
    );
};

export default GlobalErrorSnackbar; 